module.exports = __webpack_public_path__ + "img/pumpjack-horsehead-shadow.9ca4a577.png";